/* RESET GROUP USER */
export const RESET_GROUP_USER = "RESET_GROUP_USER"
export const RESET_GROUP_USER_SUCCESS = "RESET_GROUP_USER_SUCCESS"
export const RESET_GROUP_USER_CLEAN = "RESET_GROUP_USER_CLEAN"
export const RESET_GROUP_USER_ERROR = "RESET_GROUP_USER_ERROR"
